export default [
  { label: 'Nome', value: 'display_name' },
  { label: 'Produto', value: 'product_display_name' },
  { label: 'Valor', value: 'amount' },
];
